import React from "react";
// import '../Menu2.css';
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const Students = () => {
	return (
		<>
			<Navbar />
			<div>
				<Homecarousel />
			</div>
			<div
				className="problem-statement-container fadeInUp"
				style={{ backgroundImage: "url('../images/shape2.svg')" }}>
				<div className="inner-container">
					<div className="heading-container">
						<h2 className="heading-title">
							Why It Matters for Students in Agri & Food Sciences
						</h2>
					</div>

					<div className="content-container">
						<div className="content-container-1">
							<div className="content-item">
								<h4 className="content-title">Global Career Readiness:</h4>
								<p className="content-description">
									Mastery of international standards like GlobalG.A.P.,
									IndG.A.P., USDA NOP, ISO 22000, and FSSC 22000 prepares
									students for roles in agribusiness, food safety,
									certification, and export-driven enterprises worldwide.
								</p>
							</div>
							<div className="content-item">
								<h4 className="content-title">
									Entrepreneurship Opportunities:
								</h4>
								<p className="content-description">
									Understanding compliance requirements opens up avenues for
									students to become agri-consultants, quality input providers,
									farm auditors, or founders of agri-tech startups.
									<br />
									<br />
								</p>
							</div>
							<div className="content-item">
								<h4 className="content-title">
									Internships and Industry Projects:
								</h4>
								<p className="content-description">
									Access to model farms and industry partnerships provides
									real-world exposure, making academic learning more applied and
									career-oriented.
								</p>
							</div>
						</div>
						<div className="content-container-2">
							<div className="content-item">
								<h4 className="content-title">Increased Employability:</h4>
								<p className="content-description">
									Food companies, certification bodies, NGOs, and export firms
									prefer candidates with hands-on knowledge of food safety,
									sustainability, and audit standards.
								</p>
							</div>
							<div className="content-item">
								<h4 className="content-title"> Research & Innovation:</h4>
								<p className="content-description">
									Knowledge of global standards enables students to contribute
									to practical innovations in traceability, smart farming,
									climate-resilient agriculture, and digital compliance tools.
								</p>
							</div>
							{/* </div>
						<div className="content-container-2"> */}

							<div className="content-item">
								<h4 className="content-title">
									Global Mobility and Recognition:
								</h4>
								<p className="content-description">
									Certifications aligned with ISO and international benchmarks
									are recognized in over 150 countries — opening pathways for
									higher education, fellowships, and global placements.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default Students;
